module.exports = __webpack_public_path__ + "img/Tracks-Electro.add43183.webp";